import {
  type FC
} from 'react';
import {
  Box,
  type BoxProps
} from '@mui/joy';

export type CoinImageProps = Pick<BoxProps, 'sx'> & {
  code: 'SCO' | 'GCO';
};

export const CoinImage: FC<CoinImageProps> = ({
  sx,
  code,
  ...props
}) => {
  return (
    <Box
      component='img'
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      src={code === 'GCO' ? '/assets/webp/gc-coin.webp' : '/assets/webp/sc-coin.webp'}
      {...props}
    />
  );
};